import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Button,
  Grid,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import serviciosTablero from "utils/serviciosTablero";

const Solicitudes = ({
  open,
  onClose,
  tarjeta,
  setCargando,
  setMensaje,
  onSolicitudChange,
  updateData,
}) => {
  const classesTablero = useStylesTablero();
  const [solicitud, setSolicitud] = useState([]);
  const [tarjetaData, setTarjetaData] = useState([]);
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);

  const getSolicitudes = () => {
    serviciosTablero.getSolicitudesTarjeta(
      (status, mensaje, data) => {
        if (status === 1) {
          // setMensaje({ open: true, status: status, value: mensaje });
          setSolicitud(data.map((solicitud) => solicitud) || []);
        } else {
          console.error("Error al obtener la descripción:", mensaje);
          setMensaje({ open: true, status: status, value: mensaje });
        }
      },
      setCargando,
      { idtarjeta: tarjeta }
    );
  };
  const getTarjetaData = () => {
    serviciosTablero.getTarjetaData(
      (status, mensaje, data) => {
        if (status === 1) {
          // setMensaje({ open: true, status: status, value: mensaje });
          setTarjetaData(data || []);
        } else {
          console.error("Error al obtener la tarjeta:", mensaje);
          setMensaje({ open: true, status: status, value: mensaje });
        }
      },
      setCargando,
      { idtarjeta: tarjeta }
    );
  };
  const handleChange = (event, newValue) => {
    setSolicitudSeleccionada(newValue);
  };
  const asignarSolicitud = () => {
    if (solicitudSeleccionada) {
      serviciosTablero.asignarSolicitudTarjeta(
        (status, mensaje, data) => {
          if (status === 1) {
            onClose();
            onSolicitudChange(data);
            setMensaje({ open: true, status: status, value: mensaje });
            updateData('tarjeta', data, tarjeta);
          } else {
            setMensaje({ open: true, status: status, value: mensaje });
          }
        },
        setCargando,
        { idtarjeta: tarjeta, idsolicitud: solicitudSeleccionada.idsolicitud }
      );
    }
  };

  useEffect(() => {
    getSolicitudes();
    getTarjetaData();
  }, []);
  return (
    <div>
      <Autocomplete
        id="solicitud"
        options={solicitud}
        value={
          solicitud.find(
            (solicitudes) => solicitudes.idsolicitud === tarjetaData.idsolicitud
          ) || null
        }
        getOptionLabel={(option) => option.titulo}
        className={classesTablero.field}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            className={classesTablero.field}
            label="SOLICITUDES"
            variant="outlined"
          />
        )}
      />
      <DialogActions style={{ justifyContent: "flex-end" }}>
        <Grid>
          <Button
            onClick={onClose}
            className={classesTablero.btnCancelar}
            style={{ margin: "5px 0px 0 10px" }}
          >
            CANCELAR
          </Button>
        </Grid>
        <Grid>
          <Button
            onClick={asignarSolicitud}
            className={classesTablero.btnAceptar}
            style={{ margin: "5px 0px 0 10px" }}
          >
            CONFIRMAR
          </Button>
        </Grid>
      </DialogActions>
    </div>
  );
};

export default Solicitudes;
